module.exports = __webpack_public_path__ + "img/event-not-reviewed-marker.e98ba264.svg";